angular.module('bbl.module.brand-settings.routing', [])
  .config(['$routeProvider', usersRoutingSetup]);

function usersRoutingSetup($routeProvider) {
  var resolveAuth = {
    profile: ["Auth", function(Auth) {
      return Auth.getProfile().then(function(response) {
        return response.data.profile;
      });
    }], permissions: ["Auth", "$q", function(Auth, $q) {
      return Auth.getPermission().then(function(response) {
        return response.data.permission_level;
      });
    }], company: ["Auth", function(Auth) {
      return Auth.getCompanyInfo();
    }]
  };
  
  var mainRoute = {
    templateUrl: 'brand-settings-template.html',
    controller: 'BrandSettingsController',
    resolve: resolveAuth
  };

  $routeProvider.when('/brand-settings', mainRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/brand-settings/brand-settings.routing.js
 ** module id = 387
 ** module chunks = 0
 **/